export default __webpack_public_path__ + "static/media/comeraLogo.df3a35ae.png";